export default {
  simpleWorkflows: {},
}
